import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-surface-raised text-fg-muted inset-ring inset-ring-border',
  success: 'bg-success/15 text-success-fg inset-ring inset-ring-success/30',
  warning: 'bg-warning/15 text-warning-fg inset-ring inset-ring-warning/30',
  danger: 'bg-danger/15 text-danger-fg inset-ring inset-ring-danger/30',
  info: 'bg-info/15 text-info-fg inset-ring inset-ring-info/30',
};

/** Five tones, one family, one size — what the app actually uses. */
@Component({
  selector: 'app-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span [class]="classes()"><ng-content /></span>`,
})
export class BadgeComponent {
  readonly tone = input<BadgeTone>('neutral');

  protected readonly classes = computed(
    () =>
      'inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium ' +
      TONE[this.tone()],
  );
}
